export enum PARENT_COMPANY_FINANCIAL_COMPANY_SOURCE {
    SELECT_FROM_EXISTING_COMPANIES = '1',
    WRITE_THE_COMPANY_NAME = '2',
}
